import React, { useState } from "react";
import { Clock, Play } from "lucide-react";
import { GameBoard } from "../components/GameBoard";
import { DatePicker } from "../components/DatePicker";
import { istTodayStr, prettyDate } from "../lib/ist";

export const TimeMachine = () => {
  const today = istTodayStr();
  const [selected, setSelected] = useState("");
  const [playing, setPlaying] = useState(null);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 space-y-6" data-testid="time-machine-page">
      <div className="text-center">
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-wider ac-gold-text">
          ⏳ TIME MACHINE
        </h1>
        <p className="text-zinc-500 text-sm mt-1">Replay any previous daily challenge</p>
      </div>

      <div className="ac-card p-5 sm:p-6 space-y-4">
        <div className="flex items-center gap-2 text-amber-200 text-sm font-bold">
          <Clock className="w-4 h-4" /> SELECT DATE
        </div>
        <DatePicker
          value={selected}
          onChange={setSelected}
          maxToday
          testid="time-machine-date-input"
          placeholder="Select a past date"
        />
        <button
          data-testid="time-machine-play-button"
          disabled={!selected}
          onClick={() => setPlaying(selected)}
          className="btn-gold w-full py-3.5 rounded-xl font-black tracking-widest flex items-center justify-center gap-2"
        >
          <Play className="w-5 h-5" /> PLAY THIS DAY
        </button>
        <p className="text-xs text-zinc-500 text-center">
          Time Machine results are tracked separately from your daily streak.
        </p>
      </div>

      {playing && (
        <div className="space-y-3">
          <div className="text-center text-xs uppercase tracking-[0.25em] text-amber-300">
            Playing · {prettyDate(playing)}
          </div>
          <GameBoard
            key={playing}
            backendMode="daily"
            storageMode="timemachine"
            date={playing}
            showCountdown={false}
            modeLabel="TIME MACHINE"
          />
        </div>
      )}
    </div>
  );
};
